'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = getProvider;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getProvider(injector, globalInjector) {
  var _class, _temp;

  var IProvider = (_temp = _class = function (_Provider) {
    (0, _inherits3.default)(IProvider, _Provider);

    function IProvider(props, context) {
      (0, _classCallCheck3.default)(this, IProvider);

      var _this = (0, _possibleConstructorReturn3.default)(this, (IProvider.__proto__ || Object.getPrototypeOf(IProvider)).call(this, props, context));

      _this._services = {};
      for (var key in injector._services) {
        _this._services[key] = injector._services[key];
        IProvider.childContextTypes[key] = _propTypes2.default.object;
      }
      for (var _key in globalInjector._services) {
        if (_this._childContext[_key] === undefined) {
          _this._services[_key] = globalInjector._services[_key];
          IProvider.childContextTypes[_key] = _propTypes2.default.object;
        }
      }
      return _this;
    }

    (0, _createClass3.default)(IProvider, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return this._services;
      }
    }]);
    return IProvider;
  }(_reactRedux.Provider), _class.childContextTypes = {}, _temp);


  return IProvider;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/base/provider.js
// module id = 179
// module chunks = 0